import React, { useState } from "react";
import { useSnackbar } from 'notistack'
import { Empresa } from "../../../Models/Cadastros/Empresa/Empresa";
import { useConfirm } from "material-ui-confirm";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
import DataGridBuscaComponent from "../../../Components/Forms/DataGridBuscaComponent";
import EmpresaCadastroPopup from "./EmpresaCadastroPopup";

const EmpresaPesquisaPopup = (props: any) => {
    const [openCadastroPopup, setOpenCadastroPopup] = useState(false);
    const [openPopupConfirm, setOpenPopupConfirm] = useState(false);
    const [empresa, setEmpresa] = useState<any>(new Empresa());
    const closePopupAction = () => setOpenPopupConfirm(false);
    const handleCloseCadastroPopup = () => setOpenCadastroPopup(false);
    const { enqueueSnackbar } = useSnackbar();
    const confirm = useConfirm();

    const openCadastroPopupEventCallback = () => {
        setEmpresa(new Empresa());
        setOpenCadastroPopup(true);
    }

    const editarEmpresa = async (id: any) => {
        let response: any = await axios.get(`empresas/${id}`);
        setEmpresa(response.data);
        setOpenCadastroPopup(true);
    };

    const solicitaExcluirEmpresa = async (id: any) => {
        await confirm({ title: "Deseja realmente apagar este registro?" });
        enqueueSnackbar(`ID = ${id}`, {variant: 'success'});
    };

    const columns: any[] = [
        { dataIndex: 'nome_fantasia', title: 'Nome', minWidth: 200, flex: 0.3, },
        { dataIndex: 'razao_social', title: 'Razão Social', minWidth: 200, flex: 0.3, },
        { dataIndex: 'unidade', title: 'Unidade', minWidth: 200, flex: 0.2, },
        { dataIndex: 'cnpj', title: 'CNPJ/CPF', minWidth: 200, flex: 0.2, },
    ];
    
    return (
        <div>
            <BasePopup title="Empresas" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={openCadastroPopupEventCallback}>
                <DataGridBuscaComponent apiBusca="buscaEmpresas" columns={columns} onEditAction={editarEmpresa} onDeleteAction={solicitaExcluirEmpresa} fieldId='id' />
            </BasePopup>

            {openCadastroPopup ? <EmpresaCadastroPopup isOpen={openCadastroPopup} onClose={handleCloseCadastroPopup} empresa={empresa} /> : ''}
        </div>
    );
}

export default EmpresaPesquisaPopup;
